import React from "react";
import ComicBase from "../../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="La Viuda De Mi Vecina Capítulo 41– Rose Blue 3D"
      portada="https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-01-1.webp"
   paginas={[
 "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-01-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-02-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-03-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-04-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-05-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-06-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-07-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-08-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-09-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-10-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-11-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-12-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-13-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-14-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-15-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-16-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-17-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-18-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-19-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-20-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-21-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-22-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-23-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-24-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-25-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-26-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-27-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-28-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-29-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-30-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-31-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-32-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-33-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-34-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-35-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-36-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-37-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-38-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-39-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-40-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-41-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-42-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-43-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-44-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-45-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-46-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-47-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-48-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-49-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-50-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-51-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-52-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-53-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-54-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-55-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-56-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-57-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-58-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-59-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-60-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-61-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-62-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-63-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-64-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-65-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-66-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-67-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-68-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-69-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-70-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-71-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-72-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-73-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-74-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-75-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-76-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-77-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-78-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-79-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-80-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-81-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-82-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-83-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-84-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-85-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-86-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-87-1.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-88.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-89.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-90.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-91.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-92.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-93.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-94.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-95.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-96.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-97.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-98.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-99.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-100.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-101.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-102.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-103.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-104.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-105.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-106.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-107.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-108.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-109.webp"
]}
      sugeridos={[]}


      info={{
    grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
      }}
    />
  );
}

export const infoManga = {
  titulo: "La Viuda De Mi Vecina Capítulo 41– Rose Blue 3D",
  portada: "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-01-1.webp",
  reverso: "https://reycomiximg.com/wp-content/uploads/2025/04/My-Neighbors-Widow-40-RoseBlue3D-04-1.webp",
   fecha:"2026-05-17",


  info: {
  grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
  },
};
